<template>
  <validation-observer v-slot="{ invalid }">
    <v-row>
      <v-subheader class="font-weight-bold">Filter report by:</v-subheader>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <validation-provider rules="required" v-slot="{ errors }">
          <v-autocomplete
            v-model="selectedSemester"
            :items="semesterOptions"
            item-text="semesterCode"
            item-value="semesterId"
            label="Semester"
            clearable
            :error-messages="errors"
          ></v-autocomplete>
        </validation-provider>
      </v-col>
    </v-row>
    <v-row>
      <v-btn
        color="primary"
        :dark="!invalid"
        :disabled="invalid"
        outlined
        rounded
        @click="downloadReport"
        >Download Report</v-btn
      >
    </v-row>
  </validation-observer>
</template>
<script>
import { downloadFile } from "../../utils/download-utils";
export default {
  data() {
    return {
      selectedSemester: null,
    };
  },
  computed: {
    semesterOptions() {
      return this.$store.state.optionsModule.semesters.filter((item) => {
        return new Date(item.semesterStartDate) >= new Date("9/1/2023");
      });
    },
    selectedSemesterCode() {
      return this.semesterOptions.find(
        (item) => item.semesterId === this.selectedSemester
      )?.semesterCode;
    },
    fileName() {
      return (
        "Billable Units Report " + (this.selectedSemesterCode ?? "") + ".csv"
      );
    },
  },
  methods: {
    async downloadReport() {
      this.$store.commit("uxModule/setShowLoader", true);
      var response = await this.$store.dispatch(
        "reportsModule/getBillableUnitsReport",
        {
          semesterId: this.selectedSemester,
        }
      );

      if (response) {
        await downloadFile(response, this.fileName);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Oops! Something went wrong. Please try again later."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.$store.commit("uxModule/setShowLoader", false);
    },
  },
};
</script>
